<div class="container">
    <div class="me-product-labels" *ngIf="data">
        <div class="me-product-labels__header">
            {{data.headline}}
        </div>
        <div class="me-product-labels__label">
            <div class="me-product-labels__label__content" *ngFor="let section of data['labels']">
                <div>
                    <img class="me-product-labels__label__image" src="{{section.image.filename}}">
                </div>
                <div class="me-product-labels__label__text">
                    {{section.text}}
                </div>
            </div>
        </div>
    </div>
</div>